import { InjectionToken, Injectable, Inject, Optional } from '@angular/core';
import { DEBUG_INJECTION_TOKEN } from '@awp/core/config';

export const RESPONSE_LOGGER_TOKEN = new InjectionToken('Response Logger');

export interface ResponseLogger {
  log(url: string, response: any): void;
}

@Injectable()
export class ResponseConsoleLogger implements ResponseLogger {

  constructor(@Optional() @Inject(DEBUG_INJECTION_TOKEN) private debug: boolean) { }

  log(url: string, response: any): void {
    if (this.debug) {
      const dateStr = new Date();
      console.log(`Request ${url} - ${dateStr}`, response);
    }
  }
}